import React from 'react'
import { Button, Radio, Checkbox, Modal } from 'antd'
import { saveKpi } from 'api/pgads'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import TransferData from 'core/component/TransferData'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

class KPI extends React.Component {
  constructor(props) {
    super(props)
    // const editable = hasAccesPermits({
    //   authGodMode: props.envConfig.authGodMode,
    //   actionPermits: props.actionPermits,
    //   eventActions: [ScreenPermissions.MONTHLY_OPERATION_ADMIN_KPI_DATA],
    //   matchAny: true,
    // })
    this.state = {
      nercOrIso: props.setting.nercOrIso || 'N',
      omc: props.setting.omc || 'I',
      period: props.setting.period || 'YTD',
      result: [],
      template: [],
      targetKeys: props.selectedData || [],
      // editable,
      error: null,
      showErrorDialog: false,
    }
  }

  handleChange = key => e => this.setState({ [key]: e.target.value })

  saveData = targetKeys => {
    const { targetInfo, setErr, retrieveKpi } = this.props
    const { nercOrIso = 'N', omc = 'I', period = 'YTD' } = this.state
    const template = targetKeys.map((e, i) => ({ seq: i + 1, ident: e }))
    // const template=this.state.template
    saveKpi(targetInfo)({ nercOrIso, omc, period }, template).fork(
      setErr,
      () => {
        this.props.setShowKpiModal(false)
        retrieveKpi && retrieveKpi()
      }
    )
  }

  isValidTransfer = targetKeys => {
    if (targetKeys.length > 10) {
      this.setState({ error: true })
      return false
    } else {
      this.setState({ error: false })
      return true
    }
  }

  render() {
    const { nercOrIso = 'N', omc = 'I', period = 'YTD' } = this.state
    return (
      <Modal
        title="KPI Config"
        visible={this.props.showModal}
        onOk={() => {
          this.saveData(this.state.targetKeys)
        }}
        onCancel={() => this.props.setShowKpiModal(false)}
        width={900}
        height={700}
        // okText={this.state.editable ? 'Save' : 'OK'}
        style={{ top: 10 }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateRows: 'auto 400px',
            gridRowGap: '10px',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 2fr 5fr',
              gridRowGap: '10px',
            }}
          >
            <Radio
              name="nercOrIso"
              value="N"
              checked={nercOrIso === 'N'}
              onChange={this.handleChange('nercOrIso')}
              // disabled={!this.state.editable}
            >
              NERC
            </Radio>
            <Radio
              name="nercOrIso"
              value="I"
              checked={nercOrIso === 'I'}
              onChange={this.handleChange('nercOrIso')}
              // disabled={!this.state.editable}
            >
              ISO
            </Radio>
            <Checkbox
              name="omc"
              value="T"
              checked={omc === 'I'}
              onChange={e =>
                this.setState({ omc: e.target.checked ? 'I' : 'E' })
              }
              // disabled={!this.state.editable}
            >
              Include OMC
            </Checkbox>
            <Button
              style={{
                width: 'minContent',
                justifySelf: 'center',
              }}
              type="dashed"
              onClick={() => this.setState({ showErrorDialog: true })}
              // disabled={!this.state.editable}
            >
              View Current Error/Warning
            </Button>

            <Radio
              name="period"
              value="YTD"
              checked={period === 'YTD'}
              onChange={this.handleChange('period')}
              // disabled={!this.state.editable}
            >
              YTD
            </Radio>
            <Radio
              name="period"
              value="MONTH"
              checked={period === 'MONTH'}
              onChange={this.handleChange('period')}
              // disabled={!this.state.editable}
            >
              Current Month
            </Radio>
            <Radio
              name="period"
              value="12MONTHS"
              checked={period === '12MONTHS'}
              onChange={this.handleChange('period')}
              // disabled={!this.state.editable}
            >
              Last 12 Months
            </Radio>
            {this.state.error ? (
              <div
                style={{
                  textAlign: 'center',
                  // gridRowEnd: 'span 2',
                  margin: 'auto',
                  fontSize: 'large',
                  color: 'red',
                }}
              >
                Please select 10 or less items
              </div>
            ) : (
              <div />
            )}
          </div>
          {this.state.showErrorDialog && (
            <JcTmpErrorDialog
              visible={this.state.showErrorDialog}
              title="KPI Errors/Warning"
              closeErrorPrompt={() => this.setState({ showErrorDialog: false })}
              errors={this.props.data.resultStatus}
            />
          )}
          <TransferData
            style={{
              display: 'grid',
              gridTemplateColumns: '10fr 2fr 10fr',
              gridTemplateRows: '400px',
              gridColumnGap: '10px',
              margin: '1px',
            }}
            listStyle={{ height: '400px', width: 'inherit', margin: '5px' }}
            operationStyle={{ alignSelf: 'center', justifySelf: 'center' }}
            dataSource={this.props.dataItemsKpi}
            targetKeys={this.state.targetKeys}
            setTargetKeys={targetKeys => this.setState({ targetKeys })}
            isValidTransfer={this.isValidTransfer}
            titles={['Data Items', 'Selected']}
            showSearch
            showSelectAll={false}
            isRightListSelectionStoreRequired
            // selectedKeys={selectedKeys}
            // disabled={!this.state.editable}
            // onSelectChange={this.handleSelectChange}
            // onScroll={this.handleScroll}
            // disabled={disabled}
            render={a => a.displayName}
          />
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(KPI)
